import { observable, action, computed, runInAction, decorate, reaction } from 'mobx';
import agent from '../api/agent';
import { IPriorReviewSummary } from '../models/PriorReviewSummary';
import { RootStore } from './RootStore';

export default class PriorReviewSummaryStore {
    rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore
        reaction(
            () => this.predicate.keys(),
            () => {
                this.PriorReviewSummaryRegistry.clear();
            }
        )
    }

    requestResult: string | undefined;
    validating: boolean = false;
    validatedResult: boolean = false;
    submittedNote: boolean = false;
    steps: number = 0;
    priorReviewSummaryCount = 0;
    PriorReviewSummaryRegistry = new Map();
    PriorReviewSummary: IPriorReviewSummary | null = null;
    loadingInitial = false;
    submitting = false;
    target = "";
    predicate = new Map();

    get axiosParams() {
        const params = new URLSearchParams();
        this.predicate.forEach((value, key) => {
            if (key === 'startDate') {
                params.append(key, value.toISOString);
            } else {
                params.append(key, value);
            }
        })
        return params;
    }

    get requestPriorReviewSummary() {
        return this.groupPriorReviewSummaryById(Array.from(this.PriorReviewSummaryRegistry.values()));
    };

    groupPriorReviewSummaryById(priorReviewSummaries: IPriorReviewSummary[]) {
        const sortedSummaries = priorReviewSummaries.sort(
            (a, b) => parseInt(b.id) - parseInt(a.id)
        )

        return Object.entries(sortedSummaries.reduce((priorReviewSummaries, priorReviewSummary) => {
            const id = priorReviewSummary.id;
            priorReviewSummaries[id] = priorReviewSummaries[id] ? [...priorReviewSummaries[id], priorReviewSummary] : [priorReviewSummary];
            return priorReviewSummaries;
        }, {} as { [key: string]: IPriorReviewSummary[] }));
    }

    loadPriorReviewSummary = async (requestId: string | undefined) => {
        this.PriorReviewSummaryRegistry.clear();
        this.loadingInitial = true;

        try {
            const priorReviewSummaryEnvelope = await agent.PriorReviewSummary.list(requestId);
            const { priorReviewSummaryDTO, priorReviewSummaryCount } = priorReviewSummaryEnvelope;

            runInAction('loadPriorReviewSummary', () => {
                priorReviewSummaryDTO.forEach((priorReviewSummary) => {
                    this.PriorReviewSummaryRegistry.set(priorReviewSummary.id, priorReviewSummary);
                });
                this.priorReviewSummaryCount = priorReviewSummaryCount;
            });

        } catch (error) {
            throw error;
        }
        runInAction('loadPriorReviewSummary', () => {
            this.loadingInitial = false;
        });
    };

    ClearPriorReviewSummary = () => {
        this.PriorReviewSummary = null;
    }
}

decorate(PriorReviewSummaryStore, {
    PriorReviewSummaryRegistry: observable,
    PriorReviewSummary: observable,
    loadingInitial: observable,
    submitting: observable,
    validating: observable,
    target: observable,
    priorReviewSummaryCount: observable,

    loadPriorReviewSummary: action,
    ClearPriorReviewSummary: action,

    requestPriorReviewSummary: computed,
    axiosParams: computed,
});